import disabledSelectedIcon from './disabledSelect.svg';
import disabledUnSelectedIcon from './disabledUnselect.svg';
import unSelectedIcon from './unselected.png';
import noDataIcon from './noData.png';
import resetWithoutDataIcon from './resetWithoutData.png';

export {
  disabledSelectedIcon,
  disabledUnSelectedIcon,
  unSelectedIcon,
  noDataIcon,
  resetWithoutDataIcon,
};
